module.exports = __webpack_public_path__ + "img/dashboard-room.009b9fc7.jpg";